import Message from 'shared_components/message';
import { axiosPhase2API } from 'services/axios';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import HttpCodeMessage from 'shared_components/message_http_status';

export async function fetchExamList() {
	let bloodTypes = [];
	
  try{
    const response = await axiosPhase2API({
      method: API_GET_METHOD,
			url: `/general_settings/exam_items/list/`,
		});
		
		const { data } = response;
    bloodTypes = data;
  } 
  catch(e) {
    Message.error();
 	}
  
  return bloodTypes;
}

export async function createExamListAPI(payload) {
	let createBloodTypes = [];
  try{
    const axiosResponse = await axiosPhase2API({
      method: API_POST_METHOD,
      url: `/general_settings/exam_items/create/`,
      data: payload
		}).then(response => {
      return response;
    });

    // @ts-ignore
    createBloodTypes = axiosResponse;
  } 
  catch(e) {
    HttpCodeMessage({status: 500, message: e});
	}
	return createBloodTypes;
}

export async function updateExamListAPI(payload) {
  let updateExamType = [];
  const exam_item_id = payload.exam_item_id;

  try{
    const content = {
      method: API_PUT_METHOD,
      url:`/general_settings/exam_items/update/${exam_item_id}`,
      data: payload
    }

    const response = await axiosPhase2API(content);
    // @ts-ignore
    updateExamType = await response;
  }
  catch(error) {
    Message.error();
  }

  return updateExamType;
}
